import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'

import reportWebVitals from './reportWebVitals'
import App from './App'
import * as config from './config'
import * as serviceWorker from './serviceWorker'
import { isInApp } from './components/common/helpers/Mobile'

Sentry.init({
  dsn: config.app.sentry.dsn,
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
})

const start = () => {
  ReactDOM.render(
    <React.StrictMode>
      {/* TO DO: React Context: https://reactjs.org/docs/context.html */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
  )
}

// Window initialization
if (window) {
  // Chrome fix
  // See https://stackoverflow.com/questions/26483541/referenceerror-cant-find-variable-gcrweb for more info
  if (!window.__gCrWeb) window['__gCrWeb'] = {}

  // Delay initializtion for iOS and Android
  if (isInApp()) {
    // Try to delay initialization for iOS and Android
    try {
      window.bridgeStart = start
    } catch (error) {
      // If we can't delay, just start
      console.error('Error delaying initialization', error)
      Sentry.captureException(error)
      start()
    }
  } else {
    start()
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.register()
